<template>
  <div
    :class="{ [`dropdown-widget--${type}`]: type}"
    class="dropdown-widget">
    <ui-kit-select
      v-bind="$attrs"
      :value="value"
      :items="items"
      :open-triggers="openTriggers"
      title-field="shortTitle"
      class="dropdown-widget__select"
      @input="$emit('on-select', $event)"
      @open="isMobile ? $emit('open') : false">
      <template #value="{ selectedItem }">
        <div
          v-if="type === 'account'"
          class="dropdown-widget__select-account">
          <span class="dropdown-widget__select-text">My Account</span>

          <img
            :src="`/images/icons/roles/1.svg`"
            width="24"
            height="24"
            class="dropdown-widget__select-icon">
        </div>

        <div
          v-else-if="type === 'account-cashback'"
          class="dropdown-widget__select-account">
          <img
            :src="`/images/icons/roles/1.svg`"
            width="33"
            height="33"
            class="dropdown-widget__select-icon">

          <cashback-badge
            type="account"
            class="dropdown-widget__select-cashback" />
        </div>

        <div
          v-else-if="type === 'account-rate'"
          class="dropdown-widget__select-account">
          <booster-button
            class="header__button-profile"
            :pic="pic"
            :is-header="true"
            :rating="user.booster_profile.rating" />
        </div>

        <div
          v-else
          class="dropdown-widget__selected-wrapper">
          <slot
            name="icon"
            :selected-item="selectedItem">
            <img
              :src="getItemIcon(selectedItem)"
              :alt="getItemTitle(selectedItem)"
              width="24"
              height="24"
              class="dropdown-widget__selected-icon">

            <span class="dropdown-widget__selected-title">
              {{ getItemTitle(selectedItem) }}
            </span>
          </slot>
        </div>
      </template>

      <template #options="{ availableItems, selectItem, closeItems }">
        <div
          :class="{ [`dropdown-widget__options--${type}`]: type}"
          class="dropdown-widget__options">
          <div
            v-for="item in availableItems"
            :key="item.id"
            class="dropdown-widget__option"
            @click="selectOption(item, selectItem, closeItems)">
            <slot
              name="option"
              :option="item">
              <img
                :src="getItemIcon(item)"
                :alt="getItemTitle(item)"
                width="24"
                height="24"
                class="dropdown-widget__option-icon">

              <span class="dropdown-widget__option-title">
                {{ getItemTitle(item) }}
              </span>
            </slot>
          </div>
        </div>
      </template>
    </ui-kit-select>
  </div>
</template>

<script>
import UiKitSelect from 'Components/ui/Select/UiKitSelect.vue';
import { mapState, mapMutations } from 'vuex';
import SignInPopup from 'Components/Popups/SignInPopup.vue';
import CashbackBadge from 'Components/CashbackBadge.vue';
import BoosterButton from 'Components/ui/Booster/BoosterButton.vue';

export default {
  name: 'HeaderSelectWidget',

  components: {
    BoosterButton,
    UiKitSelect,
    CashbackBadge,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    value: {
      type: Object,
      required: true,
    },

    type: {
      type: String,
      default: null,
    },

    openTriggers: {
      type: Array,
      default: () => ['click', 'hover'],
    },

    pic: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState(['user', 'userDevice']),

    isMobile() {
      return this.userDevice.innerWidth < 1280;
    },
  },

  methods: {
    ...mapMutations(['mutateUser']),

    showLoginPopup() {
      this.$vuedals.openMobilePanel({
        class: 'sign-in-popup',
        component: SignInPopup,
      });
    },

    getItemIcon(item) {
      if (this.type === 'region') {
        return `/images/flags/circle/${item.shortTitle}.svg`;
      }

      return item.pic;
    },

    getItemTitle(item) {
      if (this.type === 'region') {
        return item.shortTitle;
      }

      return item.title;
    },

    selectOption(item, selectItem, closeItems) {
      if (item.callback) {
        this.$emit('select-item', item);
        closeItems();
      } else {
        selectItem(item);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .dropdown-widget {
    --icon-size: 24px;

    height: var(--height, 32px);
  }

  .dropdown-widget__select {
    --bg-color: transparent;
    --bg-color--open: #{$color--basic-menu-hsl};
    --head-elements-color--open: #{$color--basic-white};
    --height: 32px;
  }

  .dropdown-widget__selected-wrapper {
    --icon-size: 24px;

    font-size: 15px;
    font-weight: 500;
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .dropdown-widget__selected-icon {
    width: var(--icon-size);
    height: var(--icon-size);
  }

  .dropdown-widget__selected-title {
    margin-left: 8px;
    display: none;
  }

  .dropdown-widget__options {
    background-color: $color--basic-menu;
    border-radius: 4px;
    position: relative;
    padding-bottom: 4px;
    top: 3px;
  }

  .dropdown-widget__option {
    font-weight: 500;
    font-size: 13px;
    display: flex;
    align-items: center;
    padding: 13px 16px;
    cursor: pointer;
  }

  .dropdown-widget__option-icon {
    width: var(--icon-size);
    height: var(--icon-size);
    margin-right: 8px;
    max-width: none;
  }

  .dropdown-widget__option-title {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /deep/.dropdown-widget__select {
    .ui-input__error-tooltip {
      display: none;
    }

    .ui-select__value {
      width: 100%;
      height: auto;
    }

    .base-select__items {
      position: absolute;
      width: auto;
      min-width: 100%;
      top: 100%;
      right: 0;
      z-index: 1;
      overflow: hidden;
    }

    .base-select--open {
      position: relative;

      .base-select__items {
        overflow: visible;
      }
    }

    .ui-select__arrow-wrap {
      display: none;
    }
  }

  .dropdown-widget__select-account {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dropdown-widget__select-text {
    font-weight: 500;
    display: none;
  }

  .dropdown-widget__select-cashback {
    --badge-background-color: #{$color--basic-dark-gray};
    --badge-padding: 0.4em 0.5em;
  }

  /deep/.ui-select__head {
    padding: 0 10px;
  }

  .dropdown-widget--account-rate /deep/.ui-select__head {
    border-radius: 3px 3px 0 0;
  }

  @media screen and #{$screen-more-or-480} {
    .dropdown-widget--account {
      .dropdown-widget__select {
        --bg-color: #{$color--basic-green};
        --bg-color--open: #{$color--basic-green-hsl};
        --border-radius: 5px;
      }

      .dropdown-widget__select-text {
        display: inline-block;
      }

      .dropdown-widget__select-icon {
        display: none;
      }
    }
  }

  @media screen and #{$screen-less-than-640} {
    .dropdown-widget__select {
      --bg-color-head--open: transparent;
    }

    .dropdown-widget__select-icon {
      width: 20px;
      height: 20px;
    }

    .dropdown-widget__select-cashback {
      margin-left: 10px;
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .dropdown-widget__selected-wrapper,
    .dropdown-widget__select-account {
      margin-right: 11px;
    }
  }

  @media screen and #{$screen-more-or-640} {
    .dropdown-widget__selected-title {
      display: block;
    }

    /deep/.dropdown-widget__select {
      .ui-select__arrow-wrap {
        display: block;
      }
    }

    .dropdown-widget {
      --icon-size: 24px;
      --height: 40px;
    }

    /deep/.dropdown-widget--account {
      .base-select__items {
        min-width: 150px;
      }
    }

    .dropdown-widget__value {
      margin-right: 6px;
    }

    .dropdown-widget__options--account {
      top: 0;
    }

    .dropdown-widget__options:not(.dropdown-widget__options--account) {
      border-radius: 0 0 4px 4px;

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 3px;
        background-color: $color--basic-menu;
        top: -3px;
        left: 0;
      }
    }

    .dropdown-widget__option {
      --icon-size: 24px;

      padding: 8px 13px;
    }

    /deep/.dropdown-widget__select {
      --height: 40px;

      max-width: 100%;

      &.ui-select--open {
        max-width: initial;
      }

      .dropdown-widget__icon-wrapper {
        margin-right: 11px;
      }

      .base-select__value {
        position: relative;
        z-index: 1;
      }

      .ui-select__arrow-wrap {
        display: block;
      }
    }

    .dropdown-widget--region {
      min-width: 105px;
    }

    .dropdown-widget__select-cashback {
      position: absolute;
      top: 100%;
      margin-top: -13px;
    }
  }
</style>
